<script setup>
import { computed, ref, toRefs } from "vue";

const props = defineProps({
  icon: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["click"]);

const { icon, disabled } = toRefs(props);
const active = ref(false);

const getIcon = computed(() => {
  if (disabled.value) {
    return `${icon.value}/Gray5`;
  }
  if (active.value) {
    return `${icon.value}/Primary`;
  }
  return `${icon.value}/Black`;
});

const click = () => {
  if (disabled.value) {
    return;
  }
  active.value = true;
  emit("click:icon");
};
const onClickOutside = () => {
  active.value = false;
};
</script>

<template>
  <button
    v-click-outside="onClickOutside"
    class="p-chip-btn"
    @click="click"
    :class="{
      'p-chip-btn--primary': active,
      'p-chip-btn--disabled': disabled,
    }"
  >
    <p-icon :icon="getIcon" />
  </button>
</template>

<style scoped lang="scss">
.p-chip-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  cursor: pointer;
  border-radius: 4px;
  background-color: $white;
  min-width: var(--min-width);
  @include hover-before;

  &.p-chip-btn--primary {
    background-color: $primary100;
    border: 1px solid $primary;
  }
  &.p-chip-btn--disabled {
    background-color: $gray2 !important;
    border: 1px solid $gray2 !important;
    color: $gray5 !important;
    cursor: not-allowed;
    &:before {
      all: unset;
      box-sizing: border-box;
    }
    &:focus::before,
    &:hover::before {
      opacity: 0;
    }
  }
}
</style>
